var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ALLE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nutzer_header",
    transform: "translate(-89.000000, -12.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.3624628,0 L84.0049652,3.62727273 L87.2730884,3.62727273 L87.2730884,10 L89.4518371,10 L89.4518371,3.62727273 L92.7199603,3.62727273 L88.3624628,0 Z M94.898709,13.3727273 L94.898709,7 L92.7199603,7 L92.7199603,13.3727273 L89.4518371,13.3727273 L93.8093347,17 L98.1668322,13.3727273 L94.898709,13.3727273 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpdown);
export default __webpack_public_path__ + "static/media/arrow_updown.0596373010749a076aba07c9be5745c3.svg";
export { ForwardRef as ReactComponent };